export default __webpack_public_path__ + "static/media/invalid-qr.2a5641b9.svg";